import React, { Component } from 'react';
import { UncontrolledCollapse, Collapse, Container, Col, Row, ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { CrearPedido, BuscarCarritoPedido } from '../../store/sagas/carritoApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";
import ModalSinStock from '../reusable/modals/SinStock';

export class ResumenPedido extends Component {
  static displayName = ResumenPedido.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      collapse1: false,
      loading: false,
      locales: [],
      alertas: [],
      local: {},
      datosTotal: { total: 0, acumulado: 0, total: 0 },
      productos: [],
      datosLocal: {},
      localId: 0,
      pedidoId: 0,
      UrlTyC: '',
      FechaEstimadoPago: '',
      FechaEstimadoEntrega: '',
      addStock: false,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      transportista: {
        transporte: {},
        contacto: {},
        recojo: {}
      }
    };
  }

  load = (carritoProdctos, setcarritoProdctos) => {
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({
      loading: true,
      dealer: result.dealer,
      linea: result.linea,
      asociado: result.asociado,
      addStock: false
    }, () => {
      this.postBuscarCarritoPedido(carritoProdctos, setcarritoProdctos);
    });
  }

  checkParams() {
    const { state } = this.props.location;
    if (state != undefined) {
      let _datosTotal = state.datosTotal;
      let _datosLocal = state.datosLocal;
      console.log("ResumenPedido====>", state);
      console.log(_datosLocal);
      this.setState({
        datosTotal: _datosTotal,
        datosLocal: _datosLocal,
        pedidoId: state.pedidoId,
        localId: state.localId,
        transportista: state.transportista
      });
    }
  }

  IrMedioPago = () => {
    this.props.history.push({
      pathname: '/carrito-medio-pago',
      state: {
        datosTotal: this.state.datosTotal,
        datosProductos: this.state.productos,
        localId: this.state.localId,
        //pedidoId: this.state.pedidoId
      }
    });
  }

  IrEnvio = () => {
    this.props.history.push({
      pathname: '/carrito/envio',
      state: {
        datosTotal: this.state.datosTotal,
        datosProductos: this.state.productos,
        localId: this.state.localId,
        //pedidoId: this.state.pedidoId
      }
    });
  }
  IrPago = () => {
    this.props.history.push({
      pathname: '/carrito/medio-pago',
      state: {
        datosTotal: this.state.datosTotal,
        datosProductos: this.state.productos,
        localId: this.state.localId,
        datosLocal: this.state.datosLocal
        //pedidoId: this.state.pedidoId
      }
    });
  }

  IrTransportista = () => {
    this.props.history.push({
      pathname: '/carrito/transportistas',
      state: {
        datosTotal: this.state.datosTotal,
        datosProductos: this.state.productos,
        localId: this.state.localId,
        datosLocal: this.state.datosLocal,
        recojoOtro: false
        //pedidoId: this.state.pedidoId
      }
    });
  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      const auth = this.context;
      this.load(auth.carritoProdctos, auth.setcarritoProdctos);
      this.checkParams();
    } else
      window.location.href = "/";
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { collapse1, productos, alertas, datosTotal, UrlTyC, datosLocal, FechaEstimadoPago, loading, FechaEstimadoEntrega, transportista } = this.state;
    const auth = this.context;
    console.log("Medio Pago auth", auth.mostrarOfertas);
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Resumen de pedido</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard' className="active">Dashboard</Link></li>
              <li><Link to='/carrito'>Carrito de compras</Link></li>
              {(auth.mostrarOfertas) ?
                <li><Link to={{ pathname: '/carrito/ofertas', state: { datosTotal: this.state.datosTotal, datosProductos: this.state.productos, localId: this.state.localId } }}>Ofertas</Link></li>
                : null}
              <li><Link to='/carrito/envio'>Envío</Link></li>
              <li><Link to='/carrito/transportistas'>Transportista</Link></li>
              <li><Link to='/carrito/medio-pago'>Medio de Pago</Link></li>
              <li>Resumen de Pedido</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Resumen de pedido</h6>
          <div className="card container_1000">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="card_collapse w-100" style={{ maxWidth: 360, margin: 'auto' }}>
              <div className="header_collapse" id="toggler" onClick={() => { this.ToggleCollapse1() }}>
                <h6 className="paragraph-1" style={{ color: c.verdeClaro }}>Productos en tu pedido</h6>
                <div className="arrow" style={{ background: c.verdeClaro }}>
                  <SvgAssets icon={collapse1 ? "icon-top" : "icon-bottom"} fill="#fff" />
                </div>
              </div>
              <Collapse isOpen={collapse1} toggler="#toggler">
                <div className="body_collapse">
                  <ListGroup flush>
                    <ListGroupItem className="px-0">
                      <Row form>
                        <Col xs={5}></Col>
                        <Col xs={5}>
                          <span className='paragraph-3 bold text-left' style={{ color: c.verdeClaro }}>Precio Uni.</span>
                        </Col>
                        <Col xs={2}>
                          <span className='paragraph-3 bold text-left' style={{ color: c.verdeClaro }}>Can.</span>
                        </Col>
                      </Row>
                    </ListGroupItem>
                    {productos.map((item, index) => {
                      return (
                        <ListGroupItem key={index} className="px-0">
                          <Row form>
                            <Col xs={5}>
                              <span className='paragraph-2 bold' style={{ color: c.azulClaro }}>{item.maktx}</span>
                              <span className='paragraph-3' style={{ color: c.azulClaro }}>SKU: {item.matnr}</span>
                            </Col>
                            <Col xs={5}>
                              <span className='paragraph-3 bold' style={{ color: c.azulClaro }}>{item.precioPVD}</span>
                              {/* <span className='paragraph-3' style={{color:c.azulClaro}}>{item.precioPVP}</span> */}
                            </Col>
                            <Col xs={2}><span className='paragraph-2 bold' style={{ color: c.azulClaro }}>{item.cantidad}</span></Col>
                          </Row>
                        </ListGroupItem>
                      )
                    })}
                  </ListGroup>
                </div>
              </Collapse>
            </div>
            <hr className="mobile" style={{ borderColor: c.celeste, marginLeft: '-5%', marginRight: '-5%' }} />
            <hr className="desktop my-5" style={{ borderColor: c.celeste }} />
            <div className="container_680">
              <Row>
                <Col md={6} className="cards-wrap">
                  <div className="card_resumen_pedido">
                    <div className="card-header">
                      <h6 className="paragraph-1" style={{ color: '#fff' }}>Tu Pedido</h6>
                      <Link to="/carrito">
                        <button className='btn-icon'>
                          <SvgAssets icon="icon-edit" fill="#fff" />
                        </button>
                      </Link>
                    </div>
                    <div className="card-body">
                      <div className="costos">
                        <span className="light" style={{ color: c.verdeClaro }}>{datosTotal.cantidad} Productos:</span>
                        <span className="light" style={{ color: c.verdeClaro }}>{datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div className="costos">
                        <span className="light" style={{ color: c.naranja }}>Ahorro acumulado</span>
                        <span className="light" style={{ color: c.naranja }}>{datosTotal.moneda} {datosTotal.acumulado == undefined ? datosTotal.acumulado : (Number(datosTotal.acumulado)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div className="costos">
                        <span className="bold" style={{ color: c.azulClaro }}>Monto total a pagar:</span>
                        <span className="bold" style={{ color: c.azulClaro }}>{datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div className="content-fecha">
                        <div className="fecha">
                          <SvgAssets icon="icon-pago" fill={c.verdeClaro} />
                          <div>
                            <span className="paragraph-3" style={{ color: c.azulClaro }}>Fecha máxima de pago:</span>
                            <span className="paragraph-3 bold" style={{ color: c.azulClaro }}>{FechaEstimadoPago}</span>
                          </div>
                        </div>
                      </div>
                      <p className="terminos" style={{ color: c.grisMedio }}
                        disabled={UrlTyC == "" || UrlTyC == null}
                        onClick={() => this.loadInBrowser()}
                      >Al finalizar el pedido estarás de acuerdo con los <a href="javascript:void(0)">Términos y Condiciones.</a></p>
                    </div>
                  </div>
                  <div className="card_resumen_pedido desktop">
                    <div className="card-header">
                      <h6 className="paragraph-1" style={{ color: '#fff' }}>Transporte del pedido</h6>
                      <button className='btn-icon'
                        onClick={() => this.IrTransportista()}
                      >
                        <SvgAssets icon="icon-edit" fill="#fff" />
                      </button>
                    </div>
                    <div className="card-body">
                      <h6 className="paragraph-2 bold mr-2" style={{ color: c.azulClaro }}>{transportista.transporte.name1}</h6>
                      <p className="paragraph-3" style={{ color: c.azulClaro }}>Pedido lo recibe: {transportista.contacto.nombre}</p>
                      <div className="content-fecha">
                        <div className="fecha mt-1">
                          <SvgAssets icon="icon-envio" fill={c.verdeClaro} />
                          <div>
                            <span className="paragraph-3" style={{ color: c.azulClaro }}>Envío a:</span>
                            <span className="paragraph-3 bold" style={{ color: c.azulClaro }}>{transportista.recojo.desrec}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6} className="cards-wrap">
                  <div className="card_resumen_pedido">
                    <div className="card-header">
                      <h6 className="paragraph-1" style={{ color: '#fff' }}>Envío</h6>
                      <button className='btn-icon'
                        onClick={() => this.IrEnvio()}
                      >
                        <SvgAssets icon="icon-edit" fill="#fff" />
                      </button>
                    </div>
                    <div className="card-body">
                      {(datosLocal.alias != "") ?
                        <h6 className="paragraph-2 bold" style={{ color: c.azulClaro }}>Envío {datosLocal.alias}</h6>
                        : null}
                      <p className="paragraph-3" style={{ color: c.azulClaro }}>{datosLocal.direccion}</p>
                      <div className="content-fecha">
                        <div className="fecha">
                          <SvgAssets icon="icon-envio" fill={c.verdeClaro} />
                          <div>
                            {/* <span className="paragraph-3" style={{color:c.azulClaro}}>Fecha estimada de entrega: </span> */}
                            <span className="paragraph-3" style={{ color: c.azulClaro }}>{FechaEstimadoEntrega}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card_resumen_pedido mobile">
                    <div className="card-header">
                      <h6 className="paragraph-1" style={{ color: '#fff' }}>Transporte del pedido</h6>
                      <button className='btn-icon'
                        onClick={() => this.IrTransportista()}
                      >
                        <SvgAssets icon="icon-edit" fill="#fff" />
                      </button>
                    </div>
                    <div className="card-body">
                      <h6 className="paragraph-2 bold mr-2" style={{ color: c.azulClaro }}>{transportista.transporte.name1}</h6>
                      <p className="paragraph-3" style={{ color: c.azulClaro }}>Pedido lo recibe: {transportista.contacto.nombre}</p>
                      <div className="content-fecha">
                        <div className="fecha mt-1">
                          <SvgAssets icon="icon-envio" fill={c.verdeClaro} />
                          <div>
                            <span className="paragraph-3" style={{ color: c.azulClaro }}>Envío a:</span>
                            <span className="paragraph-3 bold" style={{ color: c.azulClaro }}>{transportista.recojo.desrec}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card_resumen_pedido">
                    <div className="card-header">
                      <h6 className="paragraph-1" style={{ color: '#fff' }}>Pago</h6>
                      <button className='btn-icon'
                        onClick={() => this.IrPago()}
                      >
                        <SvgAssets icon="icon-edit" fill="#fff" />
                      </button>
                    </div>
                    <div className="card-body">
                      {/* <div className="d-flex" style={{justifyContent:'space-between'}}> */}
                      <span className="paragraph-2 bold mr-2" style={{ color: c.azulClaro }}>Depósito</span>
                      <div className="content-fecha">
                        <div className="fecha mt-1">
                          <SvgAssets icon="icon-pago" fill={c.verdeClaro} />
                          <div>
                            <span className="paragraph-3" style={{ color: c.azulClaro }}>Fecha máxima de pago:</span>
                            <span className="paragraph-3 bold" style={{ color: c.azulClaro }}>{FechaEstimadoPago}</span>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                  <div className='ml-auto mr-3 desktop'>
                    <p className="total-price">TOTAL: {datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</p>
                  </div>
                </Col>
              </Row>
            </div>
            <p className="total-price mobile">TOTAL: {datosTotal.moneda} {(Number(datosTotal.total)).toLocaleString("en-US", { minimumFractionDigits: 2 })}</p>
            <div className="mobile">
              <button className='btn-block'
                type="button"
                onClick={() => this.postResumenPedido(auth.carritoProdctos, auth.setcarritoProdctos)}
              >finalizar pedido</button>
            </div>
          </div>
          <div className="desktop mt-5">
            <button className={`btn-block${(datosTotal.total <= 0 ? " disabled" : "")}`}
              type="button"
              disabled={datosTotal.total <= 0}
              onClick={() => this.postResumenPedido(auth.carritoProdctos, auth.setcarritoProdctos)}
            >finalizar pedido</button>
          </div>
        </Container>
        <ModalSinStock dadComponent={this} />
      </div>
    );
  }
  notificacion = async (alertTitulo = "", alertMensaje = "") => {
    this.setState({ alertTitulo, alertMensaje });
    this.toggleModalAlert();
  }
  toggleModalAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
    }));
  }
  showCarrito = () => {
    this.setState({ addStock: false, loading: false }, () => {
      this.props.history.push({ pathname: '/carrito', state: { datosBuscador: { localId: 0 } } })
    })
  }
  ToggleCollapse1 = () => {
    this.setState(prevState => ({ collapse1: !prevState.collapse1 }))
  }
  loadInBrowser = () => {
    window.open(this.state.UrlTyC, '_blank');
    // Linking.openURL(this.state.UrlTyC).catch(err => console.log("Couldn't load page", err));
  };
  postBuscarCarritoPedido = (carritoProdctos, setcarritoProdctos) => {
    BuscarCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.datosLocal.localId, this.state.pedidoId)
      .then(result => {
        if (result.mo.type == "success") {
          setcarritoProdctos(result.dto.carritoProdctos);
          let productosSinStock = result.dto.repuestos.filter(t => !t.validaStok).length;
          let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;

          if (productosSinStock > 0) {
            this.setState({
              addStock: true,
              loading: false
            });
          } else {
            this.setState({
              loading: false,
              productos: result.dto.repuestos,
              alertas: result.dto.alertas,
              locales: result.dto.perfil.locales,
              UrlTyC: result.dto.urlTyC,
              FechaEstimadoPago: result.dto.fechaEstimadoPago,
              FechaEstimadoEntrega: result.dto.fechaEstimadoEntrega,
              datosTotal: {
                acumulado: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].ahorroAcumulado : 0,
                total: _total,
                moneda: (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].sWaers : "",
                cantidad: result.dto.repuestos.reduce(function (acc, obj) { return acc + obj.cantidad; }, 0)
              }
            })

            if (_total == 0)
              notificacion("Carrito", data.MensajeSinProducto);
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  postResumenPedido = (carritoProdctos, setcarritoProdctos) => {
    this.setState({ loading: true })
    BuscarCarritoPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.datosLocal.localId, this.state.pedidoId)
      .then(result => {
        if (result.mo.type == "success") {
          var dataSinStock = result.dto.repuestos.filter(x => !x.validaStok)
          let _total = (result.dto.repuestos.length > 0) ? result.dto.repuestos[0].total : 0;

          if (_total == 0) {
            notificacion("Carrito", data.MensajeSinProducto);
            this.setState({ loading: false });
          }
          else {
            if (dataSinStock.length == 0) {
              this.CrearPedido(carritoProdctos, setcarritoProdctos);
            } else {
              this.setState({ addStock: true, loading: false });
            }
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }

  CrearPedido = (carritoProdctos, setcarritoProdctos) => {
    CrearPedido(this.state.dealer, this.state.linea, this.state.asociado,
      this.state.datosLocal.localId, this.state.pedidoId,
      this.state.transportista.transporte, this.state.transportista.contacto, this.state.transportista.recojo)
      .then(result => {
        if (result.mo.type == "success") {
          if (result.dto.pedido.eStPed) {
            setcarritoProdctos(0);
            this.setState({ loading: false }, () => {
              let datosPedido = { datosPedido: result.dto.pedido }
              this.props.history.push({
                pathname: '/carrito/pedido-finalizado',
                state: { datosPedido }
              });
            })
          } else {
            this.setState({ addStock: true, loading: false });
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await this.notificacion("Carrito", error.message ?? null);
        });
      });
  }
}


